import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const House = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other} width={22} height={22}>
			<path
				d="M2,11.0120123 L11.9918893,4 L15.0275347,6.12746135 L15.0282286,4.24866568 L18.2131886,4.24866568 L18.2115385,8.35708004 L22,11.011642 L21.4376705,11.7864092 L19.5224285,10.4436629 L19.5241705,18.8473257 C19.5241705,19.4222912 19.0878063,19.906882 18.5155082,19.9881936 L18.3909018,19.9993308 L5.14921969,20 C4.52657387,20 4.00536075,19.5080478 3.98108814,18.882262 L3.9801234,10.7896549 L2.56302437,11.7864354 L2,11.0120123 Z M11.9922981,5.16873498 L4.94227989,10.1141008 L4.94305913,18.8473257 C4.94305913,18.9276597 4.99940846,19.0019449 5.06876435,19.0315238 L5.12254276,19.0447215 L9.92791209,19.0451395 L9.92796794,13.4378031 L13.704535,13.4378031 L13.7031205,19.0451395 L18.3553579,19.0455332 C18.4406395,19.0455332 18.5171381,18.9899977 18.5473234,18.9241517 L18.5606923,18.8735406 L18.561238,9.77100815 L11.9922981,5.16873498 Z M12.740964,14.391644 L10.8900686,14.391644 L10.8891026,19.0451395 L12.740964,19.0451395 L12.740964,14.391644 Z M17.2503481,5.20256101 L15.9906572,5.20256101 L15.9896912,6.8010826 L17.2503481,7.68442525 L17.2503481,5.20256101 Z"
				id="house"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

House.propTypes = {
	color: PropTypes.string,
};

export default House;
